export default "__VITE_ASSET__D15B5Zqa__"